import { render } from "./PersonaFisicaMobile.vue?vue&type=template&id=4645a999"
import script from "./PersonaFisicaMobile.vue?vue&type=script&lang=js"
export * from "./PersonaFisicaMobile.vue?vue&type=script&lang=js"
script.render = render

export default script